import { render, staticRenderFns } from "./singlecard.vue?vue&type=template&id=54ae53d9&scoped=true&"
import script from "./singlecard.vue?vue&type=script&lang=js&"
export * from "./singlecard.vue?vue&type=script&lang=js&"
import style0 from "./singlecard.vue?vue&type=style&index=0&id=54ae53d9&prod&lang=less&scoped=true&"
import style1 from "./singlecard.vue?vue&type=style&index=1&id=54ae53d9&prod&lang=less&scoped=true&"
import style2 from "./singlecard.vue?vue&type=style&index=2&id=54ae53d9&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ae53d9",
  null
  
)

export default component.exports